module.exports = __webpack_public_path__ + "static/media/Preview_Red.9f876a1c.png";